const KEY = 'lux_bookings';

const getAll = () => JSON.parse(localStorage.getItem(KEY) || '[]');

export const saveBooking = (booking) => {
  const all = getAll();
  all.push({ ...booking, id: Date.now().toString(36), createdAt: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(all));
};

export const getBookings = (email) => {
  const today = new Date().toISOString().split('T')[0];
  return getAll()
    .filter((b) => b.userEmail === email)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
    .map((b) => ({ ...b, isPast: b.departureDate < today }));
};

export const getBookingCount = (email) => getAll().filter((b) => b.userEmail === email).length;
